import { FormSection } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { ProcessActivityProfessionalSummaryData } from '@common/validation/customControls/processActivityProfessionalSummaryData';
import { AllergiesAddEdit } from '@frontend/components/pages/customControls/utils/v1/allergies/AllergiesAddEdit';
import { EpisodeJournalsAddEdit } from '@frontend/components/pages/customControls/utils/v1/episodeJournals/EpisodeJournalsAddEdit';
import { LabResultsAddEdit } from '@frontend/components/pages/customControls/utils/v1/labResults/LabResultsAddEdit';
import { fetchJson } from '@frontend/store/fetch';
import { getSelectedLanguage } from '@frontend/translate';
import { usePatientEpisodeCategoryContext } from '@frontend/utils/hooks/usePatientEpisodeCategoryContext';

interface ProcessActivityProfessionalSummaryDataAddEditProps {
    onChange: (data: Partial<ProcessActivityProfessionalSummaryData>, validateKeys?: string | string[]) => void;
    processActivityId?: string;
}
export function ProcessActivityProfessionalSummaryDataAddEdit(
    props: ProcessActivityProfessionalSummaryDataAddEditProps
) {
    const { processActivityId } = props;
    const { patient } = usePatientEpisodeCategoryContext();
    const language = getSelectedLanguage();
    const [isHisDataAvailable, setIsHisDataAvailable] = useState<boolean>();

    useEffect(() => {
        loadIsHisDataAvailable();
    }, []);

    if (!isHisDataAvailable) {
        return null;
    }

    return (
        <FormSection title={language.professionalSummary.professionalSummary}>
            <AllergiesAddEdit
                onChange={async (allergies) => {
                    props.onChange({ allergies: allergies }, 'allergies');
                }}
                patient={patient}
                processActivityId={processActivityId}
            />

            <LabResultsAddEdit
                onChange={async (labResults) => {
                    props.onChange({ labResults: labResults }, 'labResults');
                }}
                patient={patient}
                processActivityId={processActivityId}
            />

            <EpisodeJournalsAddEdit
                isProcessActivity
                onChange={async (episodesAndJournals) => {
                    props.onChange({ episodesAndJournals }, ['episodesAndJournal']);
                }}
                patient={patient}
                processActivityId={processActivityId}
                variant="outline"
            />
        </FormSection>
    );

    async function loadIsHisDataAvailable() {
        let url = `/api/patients/${patient.id}/hisDataAvailability`;
        if (processActivityId) {
            url += `?processActivityId=${processActivityId}`;
        }
        const result = await fetchJson(url, 'GET');
        setIsHisDataAvailable(result.json.result);
    }
}
